import { ErrorModel } from "./error/error.model";

export class Result<T> {
  result: T;
  error: ErrorModel

  isSuccessful(): boolean {
    return this.error === null || this.error === undefined
      ? this.result !== null && this.result !== undefined && this.result !== false
      : false;
  }

  getErrorModel(): ErrorModel {
    if (this.error !== null && this.error !== undefined) {
      return this.error;
    } else {
      return ErrorModel.UNKNOWN_ERROR;
    }
  }

}
